/**
 * This enum handle card progrmmer manufactuer system handled by the system
 */
export enum CardProgrammerKind {
  UNKNOWN = 0,
  EELECTRON = 1,
  GEWISS = 2,
  SCHNEIDER = 3,
  SIEMENS = 4,
  VIMAR_EELECTRON = 5,
  VIMAR_WELLCONTACT_PLUS = 6,
  SAFLOCK_SALTOSYSTEM = 7,
  SALTO_IS = 8,
  ABB = 9,
  ABB_MILLENIUM_BUS = 10,
  ABB_TACTEO = 11,
  ABB_MILLENIUM_USB = 12,
  DAHUA = 13,
  UID_READER = 14,
  CISA = 15,
  EELECTRON_MIFARE = 16,
  VIMAR_WELLCONTACT_PLUS_NEW_DESFIRE = 17,
  BIG_MYTO_MIFARE = 18,
  VIMAR_WELLCONTACT_PLUS_NEW_MIFARE = 19,
  BLUMOTIX_2025_MIFARE = 20,
  IOS = 21,
  ANDROID = 22,
  MYTO = 23,
  CIE_READER = 24,
}

/**
 * This enum lists all the different kinds of technology used in physical cards that can be handled by the mobile application
 * (when it uses NFC to interact with them)
 */
export enum RealCardTechnologyKind {
  UNKNOWN = 0,
  MIFARE = 1,
  DESFIRE = 2,
}
